import src from "IMAGE";
export default { src, width: 240, height: 180, blurDataURL: "data:image/webp;base64,UklGRmMAAABXRUJQVlA4TFcAAAAvB0ABAM1VICICHgiACQMAAIDgtUIQCEfgGA4AAAAAAAAAAAAAAAAAAAAAAAABgYACEHcA50DfdgQAQEQkq2UKifq55FZf4tv557v6CAeeuKeowVgB2QAA", blurWidth: 8, blurHeight: 6 }
